<template>
  <div style="width: 100%; height: 100%; position: relative">
    <div v-show="!isNull" :style="{width:'100%', height:height}" :id="id"></div>
    <div v-show="isNull" :style="{width:width, height:height}" class="nostr">No Data</div>
    <!--    <div v-if="this.option.length" class="unit">-->
    <!--      单位：{{ this.unit }}-->
    <!--    </div>-->
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'ChartMacroEconomy',
  props: {
    id: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    legendDataVal: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: '10 thousand CNY'
    },
    list: {
      type: String,
    },
    option: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      dataZoomConfig: [
        {
          type: 'inside',
          start: 0,
          end: 49.99
        },
        {
          type: 'slider'
        }
      ],
      xNameList:[],
      isNull:false
    }
  },
  methods: {},
  watch: {
    option: {
      deep: true,
      handler (newVal) {
        if (newVal.length) {
          this.isNull = false
          this.xNameList = []
          const seriesData = []
          newVal.forEach(item => {
            let _data = []
            item[this.list].forEach(xItem => {
              _data = [..._data,xItem.val+'']
            })
            item[this.list].forEach(xItem => {
              this.xNameList.push(xItem.name)
            })
            this.xNameList = [...new Set(this.xNameList)]  // 数组去重
            // 判断年份对齐
            for(let vel=0;vel<this.xNameList.length;vel++){
              if(this.xNameList[vel] != item[this.list][0].name){
                _data = ['undefined',..._data]
              }else{
                break
              }
            }

            seriesData.push({
              name: item[this.legendDataVal],
              type: 'line',
              symbol: 'circle',
              smooth: true,
              data: _data
            })
          })
          let arr = undefined
          for(let ele=0;ele<seriesData.length;ele++){
             arr = seriesData[ele].data.find(item => {return item !== 'null'&& item !== 'undefined'})
             if(arr !== undefined){
                break
             }
          }
          if(arr == undefined){
            this.isNull = true
          }else{
            this.isNull = false
          }
          const chart = echarts.init(document.getElementById(this.id))
          chart.clear(seriesData);
          const option = {
            color: ['#5D88F9', '#78BDEE', '#71DBC6', '#FDAE59', '#FC83A7', '#DC4E78'],
            title: {},
            tooltip: {
              backgroundColor: 'rgba(255,255,255,0)',
              position: 'top',
              trigger : 'axis',
              formatter: (params) => {
                let item = ``
                for(let i=0;i<params.length;i++){
                  if(params[i].value == 'null' || params[i].value == 'undefined'){
                      item = item + `<p style="margin: 0; color: #000; font-size: 12px;">
                              ${params[i].seriesName}:
                              <span style="color: #409EFF">
                                  No Data
                              </span>
                          </p>`
                  }else{
                      item = item + `<p style="margin: 0; color: #000; font-size: 12px;">
                              ${params[i].seriesName}:
                              <span style="color: #409EFF">
                                  ${params[i].value}
                              </span>
                              ${this.unit}
                          </p>`
                  }
                }
                return `
                  <div style="position: relative;">
                      <div
                          style="background: #fff; padding: 8px 15px; border-radius: 4px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);">
                          <p style="margin: 0; color: #000; font-size: 14px;">${params[0].name}</p>
                          ${item}
                      </div>
                      <div style="position: absolute; bottom: 0; left: 0; width: 100%; z-index: 3; height: 10px; background: #fff; border-radius: 4px;"></div>
                      <div style="position: absolute; bottom: -5px; left: 50%; z-index: 2; margin-left: -5px; width: 10px; height: 10px; background: #fff; transform: rotate(135deg); box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);"></div>
                  </div>
                `
              }
            },
            legend: {
              icon: 'circle',
              itemWidth: 8,
              itemHeight: 8,
              itemGap: 25,
              bottom: '0px',
              textStyle: {
                fontSize: '12px',
                color: 'rgba(0, 0, 0, 0.8)',
                padding: [0, 0, 0, 0]
              }
            },
            grid: {
              left: '35px',
              right: '20px',
              top: '25px',
              bottom: '65px',
              containLabel: true
            },
            xAxis: {
              data: this.xNameList,
              type: 'category',
              axisLabel: {
                color: '#000',
              },
              splitLine: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              }
            },
            yAxis: {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: ['#EBEBEB']
                }
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              // name: this.unit,
              nameGap: 10
            },
            series: seriesData
          }
          chart.setOption(option)
        }else{
          this.isNull = true
        }
      }
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      const chart = echarts.init(document.getElementById(this.id))
      chart.resize()
    })
  }
}
</script>

<style scoped>
.unit {
  position: absolute;
  top: 10px;
  right: 35px;
  font-size: 12px;
  color: #717982;
}
.nostr{
  position: absolute;
  top: 0;
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
